export const SELLER_COLUMN_WIDTH_CLASS = 'w-80';
export const ATTRIBUTE_LABEL_COLUMN_WIDTH_CLASS = 'w-48';
export const COMPARISON_GRID_ROW_CLASS =
  'grid grid-flow-col auto-cols-max gap-x-8';
export const STICKY_ATTRIBUTE_LABEL_POSITION_CLASS = `${ATTRIBUTE_LABEL_COLUMN_WIDTH_CLASS} sticky left-0 z-10`;
export const PLAIN_ROW_BACKGROUND_CLASS = 'bg-neut-bg-alt';
export const ALTERNATE_ROW_BACKGROUND_CLASS = 'bg-neut-50';
export const STICKY_ATTRIBUTE_LABEL_CLASS = `${STICKY_ATTRIBUTE_LABEL_POSITION_CLASS} ${PLAIN_ROW_BACKGROUND_CLASS}`;

export function rowBackgroundClass(rowIndex: number): string {
  return rowIndex % 2 === 0
    ? PLAIN_ROW_BACKGROUND_CLASS
    : ALTERNATE_ROW_BACKGROUND_CLASS;
}
